<template>
  <div>
    <div class="rights_tips" v-if="!isHasAssociation">您已是協會會員</div>
    <div class="rights_tips" v-else>
      <p>（一）會員可參加深圳台協組織的聯誼和交流活動，可參與組織召開的行業洽談會、研討會等，以及行業協作與交流;</p>

      <p>（二）深圳台協加強與深圳市政府各部門間聯繫的同時，會積極組織會員與有關部門的座談、講座活動，幫助會員進一步瞭解大陸的有關政策，並通過各種方式向會員傳播經濟信息和法律信息，向會員提供法律、商務的咨詢和服務;</p>

      <p>（三）會員在工作、生活和經營過程中遇到的困難，可向協會反映，包括意見、建議和要求等，協會會予以協助;</p>

      <p>（四）依據中華人民共和國的法規，協會會積極維護會員的合法權益，會員的權利受侵害時，負責向政府有關部門反映和呼籲;</p>

      <p>（五）協會代表台資企業參加各種社會活動，舉辦社會公益事業活動，會員可參與考察、訪問、旅遊及其它活動;</p>

      <p>（六）會員享有定期出版會刊（紙質版），會刊會系統地、及時地介紹深圳的投資環境和國家有關的法規，通報台灣方面對台商到大陸投資的有關政策動態和行業動態，促進深圳與台灣兩地之間的經濟交流與合作，反饋會員的意見和建議，傳達協會的會務及財務情況;</p>

      <p>（七）會員享有協會網站的一切服務功能，包括政策文件、服務課程、企業信息上傳、活動報名等功能；其中，會員同時享有收費和免費的政策文件、服務課程；企業信息、活動報名等功能只對本協會會員開</p>

      <p>加入深圳台協，請致電：0755-83660999</p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      isHasAssociation:false,
    }
  },
  computed: {
    ...mapState(["userInfo", "user_id"]),
  },
  methods:{
    async getMyAssociationList(){
      const { data: res } = await this.$http.get(`/api/v2/member/${this.user_id}/association`,);
      if (!res.sucess) return this.$message.error("獲取失敗");
      // console.log('我的协会====',res.data)
      if(res.data.length>0){
        let filterArr=res.data.filter(item=>{
          if(item.association_id=='SZTX'){
            return item
          }
        })
        // console.log(filterArr)
        if(filterArr.length==0){
          this.isHasAssociation=true;
        }
      }else{
        this.isHasAssociation=true;
      }
    }
  },
  watch: {
    user_id(val){
      this.getMyAssociationList()
    }
  },
  mounted() {
    if(this.user_id){
      this.getMyAssociationList()
    }
  },
}
</script>

<style lang="less" scoped>
  .rights_tips{
    font-size: 18px;
    margin: 0  30px;
    color: #999;
    p{
      line-height: 40px;
    }
  }
</style>